export const KEYS = {
  ADS_REWARD_USER: () => ['ads_reward_user'] as const,
  SERVICE_CONFIG: (key: string) => ['service_config', key] as const,
}
